import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  EDITOR_LOAD_COLLECTIONS_BEGIN,
  EDITOR_LOAD_COLLECTIONS_DISMISS_ERROR,
  EDITOR_LOAD_COLLECTIONS_FAILURE,
  EDITOR_LOAD_COLLECTIONS_SUCCESS,
} from './constants';
import axios from 'axios';

export function loadCollections(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EDITOR_LOAD_COLLECTIONS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/${projectId}/project?thin=true`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EDITOR_LOAD_COLLECTIONS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EDITOR_LOAD_COLLECTIONS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadCollectionsError() {
  return {
    type: EDITOR_LOAD_COLLECTIONS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_LOAD_COLLECTIONS_BEGIN:
      return {
        ...state,
        loadCollectionsPending: true,
        loadCollectionsError: null,
      };

    case EDITOR_LOAD_COLLECTIONS_SUCCESS:
      return {
        ...state,
        loadCollectionsPending: false,
        loadCollectionsError: null,
        collections: action.data,
        showBuilderCanvasLoader: !state.showBuilderCanvasLoader,
      };

    case EDITOR_LOAD_COLLECTIONS_FAILURE:
      return {
        ...state,
        loadCollectionsPending: false,
        loadCollectionsError: action.data.error,
      };

    case EDITOR_LOAD_COLLECTIONS_DISMISS_ERROR:
      return {
        ...state,
        loadCollectionsError: action.data,
      };

    default:
      return state;
  }
}
